let data17;
if (typeof window === "undefined") {
  data17 = require("../static-s17/Data.json");
} else {
  // data17 = require("../static-s17/Data.json");
  // window.data17 = data17;
  data17 = window.data17;
}

export { data17 };
